import { useState } from 'react';
import { Bell, Check, X, Loader2, Clock } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { useIntercomRequests, useRespondIntercom } from '@/hooks/useIntercomRequests';

export function IntercomInbox() {
  const { data: requests, isLoading } = useIntercomRequests();
  const respond = useRespondIntercom();
  const [respondingId, setRespondingId] = useState<string | null>(null);

  if (isLoading || !requests || requests.length === 0) return null;

  const handleRespond = async (requestId: string, action: 'approve' | 'deny') => {
    setRespondingId(requestId);
    try {
      await respond.mutateAsync({ requestId, action });
    } finally {
      setRespondingId(null);
    }
  };

  return (
    <div className="space-y-3">
      <div className="flex items-center gap-2">
        <Bell className="h-4 w-4 text-primary" />
        <h3 className="text-sm font-semibold">
          Porttelefon ({requests.length})
        </h3>
      </div>

      {requests.map((req) => {
        const isResponding = respondingId === req.id;
        const timeLeft = Math.max(0, Math.floor((new Date(req.expires_at).getTime() - Date.now()) / 1000));
        const minutes = Math.floor(timeLeft / 60);
        const seconds = timeLeft % 60;

        return (
          <Card key={req.id} className="border-primary/30 bg-primary/5">
            <CardContent className="py-3 px-4">
              <div className="flex items-start justify-between gap-3">
                <div className="flex-1 min-w-0">
                  <p className="font-medium text-sm truncate">
                    {req.visitor_name}
                  </p>
                  <p className="text-xs text-muted-foreground">
                    söker dig vid {req.device?.name || 'enhet'}
                  </p>
                  <div className="flex items-center gap-1 mt-1 text-xs text-muted-foreground">
                    <Clock className="h-3 w-3" />
                    <span className="font-mono">{minutes}:{String(seconds).padStart(2, '0')}</span>
                  </div>
                </div>

                <div className="flex gap-2 flex-shrink-0">
                  <Button
                    size="sm"
                    variant="outline"
                    className="h-8 w-8 p-0 border-red-300 text-red-600 hover:bg-red-50 dark:border-red-700 dark:text-red-400 dark:hover:bg-red-900/20"
                    onClick={() => handleRespond(req.id, 'deny')}
                    disabled={isResponding}
                  >
                    {isResponding ? <Loader2 className="h-4 w-4 animate-spin" /> : <X className="h-4 w-4" />}
                  </Button>
                  <Button
                    size="sm"
                    className="h-8 w-8 p-0 bg-green-600 hover:bg-green-700 text-white"
                    onClick={() => handleRespond(req.id, 'approve')}
                    disabled={isResponding}
                  >
                    {isResponding ? <Loader2 className="h-4 w-4 animate-spin" /> : <Check className="h-4 w-4" />}
                  </Button>
                </div>
              </div>
            </CardContent>
          </Card>
        );
      })}
    </div>
  );
}
